import { defineField, defineType } from "sanity";
import { PortableTextBlock } from "sanity";

export const DEFAULT_LANGUAGE = "de";
export const NON_DEFAULT_LANGUAGES = ["en"];

export const I18nTextType = defineType({
  name: "i18nText",
  type: "object",
  title: "Translations",
  options: {
    collapsible: true,
    collapsed: true,
  },
  fields: [
    defineField({
      name: "en",
      title: "English (EN)",
      type: "string",
    }),
  ],
});

export interface II18nText {
  en?: string;
}

export function resolveI18nText(
  defaultText: string | undefined,
  i18n: II18nText | undefined,
  language: string | undefined,
): string {
  const text = defaultText ?? "";
  if (!language || language === DEFAULT_LANGUAGE) return text;
  return i18n?.[language as keyof II18nText] || text;
}

export const I18nRichtextType = defineType({
  name: "i18nRichtext",
  type: "object",
  title: "Translations",
  options: {
    collapsible: true,
    collapsed: true,
  },
  fields: [
    defineField({
      name: "en",
      title: "English (EN)",
      type: "richtext",
    }),
  ],
});

export interface II18nRichtext {
  en?: PortableTextBlock[];
}

export function resolveI18nRichtext(
  defaultContent: PortableTextBlock[] | undefined,
  i18n: II18nRichtext | undefined,
  language: string | undefined,
): PortableTextBlock[] | undefined {
  if (!language || language === DEFAULT_LANGUAGE) return defaultContent;
  return i18n?.[language as keyof II18nRichtext] ?? defaultContent;
}
